<template lang="html">
  <section class="form-box" :class="{incompleted: !completed}" id="forditas-urlap-adatok" ref="main">
    <div class="container">
      <div class="row">
        <h2 class="urlap-title">Adatok</h2>
        <div class="">
          Kérjük adja meg elérhetőségi adatait. Így az árajánlatot továbbíthatja saját e-mail címére későbbi megrendelés céljából.<span class="required-field">*</span>
        </div>
      </div>
      <div class="row">
        <div class="form-box-item form-group" :class="{invalid: !emailValid}">
          <input v-model="modelEmail" type="email" class="form-control" name="email" placeholder="Email cím" :disabled="megerosites">
        </div>
      </div>
      <div class="row">
        <div class="form-box-item form-group" :class="{invalid: !phoneValid}">
          <input v-model="modelPhone" type="tel" class="form-control" name="phone" placeholder="Telefonszám" :disabled="megerosites">
        </div>
      </div>
      <button ref="sendAdatokBtn" type="button" style="display: none" @click="track();sendAdatok(false)">
        Adatok megerősítése
      </button>
      <div id="send-adatok" class="row" v-if="emailValid && phoneValid">
        <div v-if="megerosites" id="adatok-megerositese-message" class="alert alert-success" role="alert">
          Adatok megerősítve!
        </div>
        <button v-else ref="sendAdatokBtnContinue" type="button" class="btn btn-secondary" @click="sendAdatok(true)" :disabled="waitMegerosites">
          Adatok megerősítése
        </button>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  data: function(){
    return {
      email$: '',
      phone$: '',
      waitMegerosites: false
    }
  },
  props: [
    'email',
    'phone',
    'apiUrl',
    'megerosites'
  ],
  created() {
    //init values
    this.email$ = this.email
    this.phone$ = this.phone
  },
  mounted() {
    if(location.hash == '#forditas-urlap-adatok') {
      // let mainElement = this.$refs.main
      this.$refs.main.scrollIntoView({behavior: "smooth", block: "end"})
    }

  },
  computed: {
    modelEmail: {
      get() {
        return this.email$
      },
      set(val) {
        this.email$ = val
        //csak valid esetekben történik küldés
        if(this.emailIsValid(val)) {
          this.$emit('update:email',val)
        }
        //egyébként törlés
        else {
          this.$emit('update:email','')
        }
      }
    },
    modelPhone: {
      get() {
        return this.phone$
      },
      set(val) {
        this.phone$ = val
        if(this.phoneIsValid(val)) {
          this.$emit('update:phone',val)
        } else {
          this.$emit('update:phone','')
        }
      }
    },
    emailValid() {
      return this.emailIsValid(this.email$)
    },
    phoneValid() {
      return this.phoneIsValid(this.phone$)
    },
    completed() {
      return this.phoneValid && this.emailValid
    }
  },
  methods: {
    emailIsValid(emailVal) {
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailVal)
    },
    phoneIsValid(phoneVal) {
      return true || phoneVal.length > 3
    },
    
    // Adatok megerősítése gombra kattintás esemény követése
    track() {
        this.$gtag.event('AdatokMegerositese', {
          'event_category': 'BUTTON'
        })
    },

    sendAdatok(setDisabled){
      // ha nincs kitöltve legalább az e-mail, akkor ne jöjjön létre "üres" rendelés
      if ( !this.email ) {
        return;
      }

      let formData = new FormData()
      //waiting status enabled
      this.waitMegerosites = true
      formData.append('method','sendAdatok')
      formData.append('data', JSON.stringify({
        phone: this.phone,
        email: this.email
      }))

      this.$http.post(
        `${this.apiUrl}sendAdatok`,
        formData
      ).then((response) => {
        if(response.data) {
          if (setDisabled === true) {
            // itt a waitMegerősítés true lesz
            this.$emit('update:megerosites',true)
          }
        }
        this.waitMegerosites = false
      })
      .catch( () => {
        this.waitMegerosites = false
        console.log('Az adatok megerősítése közben hiba történt!');
      })
    }
  }
}
</script>
<style lang="scss">
#send-adatok{
  button{
    height: 35px;
    text-transform: none;
    line-height: normal;
    &:hover{
      color: white;
    }
  }
}
@keyframes cssAnimation {
    to {
        width:0;
        height:0;
        padding: 0;
        overflow:hidden;
    }
}
@-webkit-keyframes cssAnimation {
    to {
        width:0;
        height:0;
        padding: 0;
        visibility:hidden;
    }
}
$delay: 10s;
#adatok-megerositese-message{
  -moz-animation: cssAnimation 0s ease-in $delay forwards;
  /* Firefox */
  -webkit-animation: cssAnimation 0s ease-in $delay forwards;
  /* Safari and Chrome */
  -o-animation: cssAnimation 0s ease-in $delay forwards;
  /* Opera */
  animation: cssAnimation 0s ease-in $delay forwards;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}
</style>
